import classNames from 'classnames';

import { CenteredSpinner } from '../CenteredSpinner/CenteredSpinner';

import type { EnrichedTag, SvpAsset, SvpCategory } from '../../types';
import type { ReactNode } from 'react';

import styles from './Slider.module.scss';

type Props<T> = {
  items: T[];
  isFetching?: boolean;
  renderItem?: (item: T) => ReactNode;
  isSmall?: boolean;
};

function Slider<T extends EnrichedTag | SvpCategory | SvpAsset>({
  items,
  isFetching = false,
  renderItem,
  isSmall,
}: Props<T>) {
  return (
    <div
      className={classNames(styles.slider, {
        [styles.isLoading]: isFetching,
        [styles.isSmall]: isSmall,
      })}
    >
      {isFetching ? (
        <CenteredSpinner />
      ) : (
        items.map((item, index) => (
          <div className={styles.item} key={index}>
            {renderItem?.(item)}
          </div>
        ))
      )}
    </div>
  );
}

export { Slider };
